import { Amplify } from "aws-amplify";
import "aws-amplify/auth/enable-oauth-listener";
import { getConfig } from "@/lib/runtime-config";

let configured = false;

export function configureAmplify(): void {
  if (configured) return;
  const config = getConfig();
  if (!config.cognitoUserPoolId || !config.cognitoAppClientId) {
    // Allow the app to boot in unit-test/dev environments without Cognito.
    configured = true;
    return;
  }
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.cognitoUserPoolId,
        userPoolClientId: config.cognitoAppClientId,
        loginWith: {
          oauth: {
            domain: config.cognitoDomain,
            scopes: ["openid", "email", "profile"],
            redirectSignIn: [`${window.location.origin}/auth/callback`],
            redirectSignOut: [`${window.location.origin}/`],
            responseType: "code",
          },
        },
      },
    },
  });
  configured = true;
}
